import { FlexBoxProps } from '@xylabs/sdk-react'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import { DateTime } from 'luxon'
import React from 'react'

import { useAuction } from '../Contexts'
import Timer from './Timer'

interface Props extends FlexBoxProps {
  quadkey?: Quadkey
}

const EndTimer: React.FC<Props> = ({ quadkey, ...props }) => {
  const { auction } = useAuction(quadkey)

  let prefix = ''
  let endTimeMs = auction?.static?.endTime ? auction?.static?.endTime * 1000 : undefined

  if (auction?.static?.minted) {
    prefix = 'Minted'
    endTimeMs = undefined
  } else {
    if (auction?.static?.started !== undefined) {
      if (auction?.static?.started) {
        prefix = DateTime.fromMillis(endTimeMs ?? 0) > DateTime.now() ? 'Ends' : 'Ended'
      } else {
        prefix = 'Not Started'
        endTimeMs = undefined
      }
    }
  }

  return <Timer prefix={prefix} time={endTimeMs} {...props} />
}

export default EndTimer
